@if (product()) {
    <!-- #region bullet point box -->
    @if (product().presentation.bulletPoints.length) {
        <app-info-box
            headline="Deine Vorteile"
            [bulletPoints]="product().presentation.bulletPoints"
        >
        </app-info-box>
    }
    <!-- #endregion -->
}
